if (!customElements.get('shoppable-slider')) {
  class ShoppableSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.sectionId = this.dataset.sectionId;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll(`.slide-content-${this.sectionId}`);
      this.hotspots = this.querySelectorAll(`.hotspot-${this.sectionId}`);
      this.prevArrow = this.querySelector(`.prev-arrow-${this.sectionId.replace(/-/g, '_')}`);
      this.nextArrow = this.querySelector(`.next-arrow-${this.sectionId.replace(/-/g, '_')}`);
      this.makeSetButton = this.querySelector('.make-this-your');
      this.totalSlides = this.slides.length;

      this.init();
    }

    init() {
      // Hotspot click events
      this.hotspots.forEach((hotspot, index) => {
        hotspot.addEventListener('click', () => this.switchSlide(index));
      });

      // Arrow click events
      if (this.prevArrow) {
        this.prevArrow.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextArrow) {
        this.nextArrow.addEventListener('click', () => this.nextSlide());
      }

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });

      // Cart addition
      if (this.makeSetButton) {
        this.makeSetButton.addEventListener('click', () => this.addAllToCart());
      }

      this.updateSlides();
    }

    switchSlide(index) {
      if (index >= 0 && index < this.totalSlides) {
        this.currentSlide = index;
        this.updateSlides();
      }
    }

    nextSlide() {
      if (this.currentSlide < this.totalSlides - 1) {
        this.currentSlide++;
        this.updateSlides();
      }
    }

    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
        this.updateSlides();
      }
    }

    updateSlides() {
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('active', index === this.currentSlide);
      });

      this.hotspots.forEach((hotspot, index) => {
        hotspot.classList.toggle('active', index === this.currentSlide);
      });

      if (this.prevArrow) this.prevArrow.disabled = (this.currentSlide === 0);
      if (this.nextArrow) this.nextArrow.disabled = (this.currentSlide === this.totalSlides - 1);
    }

    addAllToCart() {
      const items = [];
      this.slides.forEach(slide => {
        const variantId = slide.dataset.variantId;
        if (variantId) {
          items.push({
            id: variantId,
            quantity: 1 // Fixed as per user request (was potentially 3)
          });
        }
      });

      if (items.length > 0) {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(response => {
          if (!response.ok) throw new Error('Failed to add items to cart');
          return response.json();
        })
        .then(() => {
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(err => {
          console.error(err);
          alert('There was an error adding the products to the cart.');
        });
      }
    }
  }

  customElements.define('shoppable-slider', ShoppableSlider);
}
